import { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const Banner = ({ message, type }) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !message) return null;

  return (
    <StyledBanner className={type} role="alert">
      {type !== 'alert' && <div className="spacer" />}
      {message}
      {type !== 'alert' && (
        <DismissButton onClick={() => setDismissed(true)} aria-label="Dismiss banner">
          <Icon className="close">close</Icon>
        </DismissButton>
      )}
    </StyledBanner>
  );
};

const StyledBanner = styled.div`
  color: ${({ theme }) => theme.colors.secondary};
  font: ${({ theme }) => theme.regularBoldFont};
  min-height: 35px;
  text-align: center;
  padding: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &.info {
    background-color: ${({ theme }) => theme.colors.feedback.info};
  }

  &.alert {
    background-color: ${({ theme }) => theme.colors.feedback.error};
  }

  & .spacer {
    width: 25px;
    height: 25px;
    margin-right: auto;
  }
`;

const DismissButton = styled.button`
  display: flex;
  background: none;
  border: none;
  margin-left: auto;
  cursor: pointer;
  align-items: center;

  & .close {
    fill: ${({ theme }) => theme.colors.secondary};
    margin: 0;
    height: 25px;
    width: 25px;
  }
`;

Banner.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['info', 'alert']).isRequired,
};

export default Banner;
